import React from "react";
import { Key, Target, CheckCircle, Clock } from "lucide-react";

const AnalyticsStatCards = ({ metrics = {} }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {/* Card 1: Total Requests */}
      <div className="bg-white rounded-xl border border-gray-200 p-5 flex items-center justify-between shadow-sm">
        <div>
          <h3 className="text-xs font-semibold text-gray-500 mb-1">Total Requests</h3>
          <p className="text-2xl font-bold text-gray-900 mb-1">{metrics.totalRequests || "0"}</p>
          <p className="text-xs font-medium text-emerald-600 flex items-center gap-1">
            <span>↗</span> {metrics.requestsChange || "+0% vs last week"}
          </p>
        </div>
        <div className="w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center text-amber-500">
          <Key className="w-5 h-5" />
        </div>
      </div>

      {/* Card 2: Total Tokens Used */}
      <div className="bg-white rounded-xl border border-gray-200 p-5 flex items-center justify-between shadow-sm">
        <div>
          <h3 className="text-xs font-semibold text-gray-500 mb-1">Total Tokens Used</h3>
          <p className="text-2xl font-bold text-gray-900 mb-1">{metrics.totalTokens || "0"}</p>
          <p className="text-xs font-medium text-emerald-600 flex items-center gap-1">
            <span>↗</span> {metrics.tokensChange || "+0% vs last week"}
          </p>
        </div>
        <div className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-500">
          <Target className="w-5 h-5" />
        </div>
      </div>

      {/* Card 3: Total Success Rate */}
      <div className="bg-white rounded-xl border border-gray-200 p-5 flex items-center justify-between shadow-sm">
        <div>
          <h3 className="text-xs font-semibold text-gray-500 mb-1">Total Success Rate</h3>
          <p className="text-2xl font-bold text-gray-900 mb-1">{metrics.successRate || "100%"}</p>
          <p className="text-xs font-medium text-emerald-600 flex items-center gap-1">
            <span>↗</span> {metrics.successChange || "+0% vs last week"}
          </p>
        </div>
        <div className="w-10 h-10 rounded-full bg-teal-50 flex items-center justify-center text-teal-500">
          <CheckCircle className="w-5 h-5" />
        </div>
      </div>

      {/* Card 4: Avg Response Time */}
      <div className="bg-white rounded-xl border border-gray-200 p-5 flex items-center justify-between shadow-sm">
        <div>
          <h3 className="text-xs font-semibold text-gray-500 mb-1">Avg Response Time</h3>
          <p className="text-2xl font-bold text-gray-900 mb-1">{metrics.avgResponseTime || "0ms"}</p>
          <p className="text-xs font-medium text-emerald-600 flex items-center gap-1">
            <span>↗</span> {metrics.timeChange || "0ms from last week"}
          </p>
        </div>
        <div className="w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center text-amber-500">
          <Clock className="w-5 h-5" />
        </div>
      </div>
    </div>
  );
};

export default AnalyticsStatCards;
